const STATUS_TO_KEY = {
  PUBLISHED: 'active',
  DRAFT: 'draft',
};

const getCalendarDayTooltip = (entry, t) => {
  const key = STATUS_TO_KEY[entry.status];
  if (!key) return null;

  const titleKey = key === 'active' ? 'activeTalkingPoint' : 'draftTalkingPoint';
  const messageKey = key === 'active' ? 'activeTalkingPointMessage' : 'draftTalkingPointMessage';

  return {
    htmlComponent: `<div style="color: var(--color-semantic-white); font-size: var(--font-body3)"><strong>${t(`formTalkingPoint.${titleKey}`)}</strong><p>${t(`formTalkingPoint.${messageKey}`)}</p></div>`,
  };
};

export default getCalendarDayTooltip;